module.exports = __webpack_public_path__ + "assets/fe28d302cb606ebc8b15cc5a47ce0d1b.png";